<template>
  <div>
    <div class="header">
      <h1 class="header-title">Dashboard</h1>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-4">
          <div class="card pt-3">
            <div class="card-body d-flex">
              <div>
                <router-link
                  :to="{
                    name: 'writer.orders',
                    query: { status: 'in-progress' },
                  }"
                >
                  <i class="fal fa-calendar-check" style="font-size: 40px"></i>
                </router-link>
              </div>
              <div class="px-3">
                <router-link
                  :to="{
                    name: 'writer.orders',
                    query: { status: 'in-progress' },
                  }"
                >
                  <h4>In Progress Orders</h4>
                  <p class="mb-0">{{ stats.in_progress }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card pt-3">
            <div class="card-body d-flex">
              <div>
                <router-link
                  :to="{ name: 'writer.orders', query: { status: 'review' } }"
                >
                  <i class="fal fa-align-slash" style="font-size: 40px"></i>
                </router-link>
              </div>
              <div class="px-3">
                <router-link
                  :to="{ name: 'writer.orders', query: { status: 'review' } }"
                >
                  <h4>Pending Review</h4>
                  <p class="mb-0">{{ stats.review }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card pt-3">
            <div class="card-body d-flex">
              <div>
                <router-link
                  :to="{ name: 'writer.orders', query: { status: 'complete' } }"
                >
                  <i class="fal fa-align-slash" style="font-size: 40px"></i>
                </router-link>
              </div>
              <div class="px-3">
                <router-link
                  :to="{ name: 'writer.orders', query: { status: 'complete' } }"
                >
                  <h4>Completed Orders</h4>
                  <p class="mb-0">{{ stats.complete }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
              <router-link
                :to="{ name: 'writer.orders' }"
                class="btn btn-primary btn-sm float-end"
                >View All<i class="fal fa-arrow-right me-0 ms-2"></i
              ></router-link>
              <h4>Orders In Progress</h4>
              <table class="table">
                <thead>
                  <tr>
                    <th>Order No.</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Category</th>
                    <th>Quality</th>
                    <th>Words</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="orders.length == 0">
                    <td colspan="7">There is no data to display.</td>
                  </tr>
                  <tr v-for="(order, i) in orders" :key="`order-${i}`">
                    <td>
                      <router-link
                        class="text-primary"
                        :to="{
                          name: 'writer.orders.show',
                          params: { id: order.id },
                        }"
                        >{{ order.id }}</router-link
                      >
                    </td>
                    <td>
                      <router-link
                        class="text-primary"
                        :to="{
                          name: 'writer.orders.show',
                          params: { id: order.id },
                        }"
                        >{{ order.title }}</router-link
                      >
                    </td>
                    <td>{{ order.type }}</td>
                    <td>{{ order.category }}</td>
                    <td width="120px">
                      <quality :quality="{ stars: order.stars }" />
                      <span>{{ order.quality }}</span>
                    </td>
                    <td>{{ order.min }} - {{ order.max }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="loading" />
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      stats: {},
      orders: [],
      loading: true,
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios.get("/api/v1/writer/home").then((response) => {
        this.stats = response.data.stats;
        this.orders = response.data.orders;
        this.loading = false;
      });
    },
  },
};
</script>
